<template>
  <div class="vld-parent">
    <loading
      :active="isLoading"
      :color="'#2E75B5'"
      :height="90"
      :width="90"
    />
  </div>
</template>

<script>
export default {

  props: {
    isLoading: Boolean,
  },
}
</script>
